import React from 'react'
import { ArtworksList, NoResults } from 'components/Artworks/styles/list'
import type { ConnectorProps as ListProps } from '../../connectors/List'
import ListConnector from '../../connectors/List'
import Artwork from './Artwork'

const Component = (props: ListProps): React.ReactElement<React.ComponentProps<any>, any> => {
  const {
    algoliaIndice,
    algoliaQueryId,
    algoliaUserToken,
    artworks,
    isMobileScreen,
    isScreenReady,
  } = props
  const isMobile = isMobileScreen && isScreenReady

  if (!artworks.length) {
    return <NoResults>Sorry, no results were found for that query.</NoResults>
  }

  return (
    <ArtworksList data-device={isMobile ? 'mobile' : 'desktop'}>
      {artworks.map(({ artworkId }, index) => {
        const priority = index === 0
        const lazyLoad = index > 3
        return (
          <Artwork
            algoliaIndice={algoliaIndice}
            algoliaQueryId={algoliaQueryId}
            algoliaUserToken={algoliaUserToken}
            artworkId={artworkId}
            hasPrints={false}
            index={index}
            isMobile={isMobile}
            key={`artwork-${artworkId}`}
            priority={priority}
            lazyLoad={lazyLoad}
          />
        )
      })}
    </ArtworksList>
  )
}

export default ListConnector(Component)